/**
 * Portal Manta · BotoeiraAcoes
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { M, F, STATUS } from '../../tokens/theme.js';
import { PAYLOAD_LOTE1_PR } from '../../data/payload-lote1-pr.js';
import { PRESETS_NOVO_ESTUDO } from '../../data/presets-novo-estudo.js';

const BotoeiraAcoes = memo(function BotoeiraAcoes_Inner({onAplicarPreset, onAbrirImport, onIniciarPayload}){
  const [presetSel, setPresetSel] = useState('');
  const handlePreset = () => {
    if (!presetSel) return;
    const preset = PRESETS_NOVO_ESTUDO.find(p => p.id === presetSel);
    if (!preset) return;
    onAplicarPreset(preset);
    setPresetSel('');
  };
  const btnStl = {
    padding:'7px 14px', border:`1px solid ${M.border}`, background:'#fff',
    fontFamily:F.mono, fontSize:10.5, fontWeight:600, color:M.title, letterSpacing:.5,
    cursor:'pointer', borderRadius:3, transition:'all .15s',
  };
  return (<div>
    {/* Linha 1 · Extração massiva (payload pré-carregado) */}
    {onIniciarPayload && (<div style={{
      marginBottom:10, padding:'10px 14px',
      background:'#D1FAE5', border:`1px solid #10B981`, borderRadius:4,
      display:'flex', alignItems:'center', gap:10,
    }}>
      <span style={{fontSize:14}}>🚀</span>
      <div style={{flex:1, fontSize:11, color:'#065F46', lineHeight:1.45}}>
        <b>Extração rápida</b> · carregar todos os 40 campos do Lote 1 PR de uma vez (24 quali extraídos + 16 quanti extraídos · fontes atribuídas automaticamente).
      </div>
      <button onClick={()=>onIniciarPayload(PAYLOAD_LOTE1_PR)} style={{
        padding:'6px 14px', background:'#10B981', color:'#fff', border:'none', borderRadius:3,
        fontFamily:F.mono, fontSize:10.5, fontWeight:700, letterSpacing:.5, cursor:'pointer',
      }}>
        INICIAR LOTE 1 PR
      </button>
    </div>)}

    {/* Linha 2 · Ações individuais */}
    <div style={{
      marginBottom:18, padding:'10px 14px',
      background:M.bgAlt, border:`1px solid ${M.borderSoft}`, borderRadius:4,
      display:'flex', alignItems:'center', gap:10, flexWrap:'wrap',
    }}>
      <span style={{fontSize:14}}>⚡</span>
      <div style={{fontFamily:F.mono, fontSize:10.5, color:M.muted, marginRight:8, letterSpacing:.5, textTransform:'uppercase', fontWeight:600}}>
        Ações
      </div>
      <button style={btnStl} onClick={()=>onAbrirImport('pdf')}>📥 PDF</button>
      <button style={btnStl} onClick={()=>onAbrirImport('json')}>📄 JSON</button>
      <button style={btnStl} onClick={()=>onAbrirImport('excel')}>📊 EXCEL</button>
      <button style={btnStl} onClick={()=>onAbrirImport('sharepoint')}>☁ SHAREPOINT</button>
      <div style={{width:1, height:22, background:M.border, margin:'0 4px'}}></div>
      <select value={presetSel} onChange={e=>setPresetSel(e.target.value)} style={{
        padding:'6px 10px', border:`1px solid ${M.border}`, borderRadius:3,
        fontFamily:F.body, fontSize:11, background:'#fff', minWidth:200,
      }}>
        <option value="">— escolher preset —</option>
        {PRESETS_NOVO_ESTUDO.map(p => (
          <option key={p.id} value={p.id}>{p.titulo}</option>
        ))}
      </select>
      <button onClick={handlePreset} disabled={!presetSel} style={{
        ...btnStl,
        background: presetSel ? M.accent : '#E5E7EB',
        color: presetSel ? '#fff' : '#9CA3AF',
        borderColor: presetSel ? M.accent : '#E5E7EB',
        cursor: presetSel ? 'pointer' : 'not-allowed',
      }}>📦 MESCLAR</button>
    </div>
  </div>);
});

export { BotoeiraAcoes };
export default BotoeiraAcoes;
